import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { FormRenderer } from "../components/forms/FormRenderer";

export default function FormFill() {
  const { id } = useParams();
  const [form, setForm] = useState(undefined);
  useEffect(() => { api.get(`/forms-fill/${id}`).then((r) => setForm(r.data)).catch(() => setForm(null)); }, [id]);
  if (form === undefined) return <div className="p-10 text-sm text-muted-foreground">Loading form…</div>;
  if (form === null) return <div className="p-10 text-sm" data-testid="form-fill-missing">This form couldn't be found in this entity. <Link to="/app/forms" className="text-[#C2A462] underline">Back to Forms</Link></div>;
  if (form.already_completed) return <div className="p-10 text-sm" data-testid="survey-already-done">You've already completed this survey. Thank you! <Link to="/app/essentials" className="text-[#C2A462] underline">Back to Document Essentials</Link></div>;
  const submit = async (answers) => {
    try { const { data } = await api.post(`/forms-fill/${id}/submit`, { answers, consent: (form.fields || []).every((f) => f.type !== "consent" || answers[f.key] === true) }); return { ok: true, message: data.message }; }
    catch (e) { return { ok: false, message: errMsg(e) }; }
  };
  const draft = async (answers) => {
    try { await api.put(`/forms-fill/${id}/draft`, { answers }); toast.success("Draft saved. You can come back and finish it later."); return { ok: true }; }
    catch (e) { return { ok: false, message: errMsg(e) }; }
  };
  return (
    <div data-testid="form-fill-page">
      {form.draft_saved_at && <div className="mb-3 rounded-md border border-[#C2A462]/30 bg-[#C2A462]/10 px-4 py-2 text-sm" data-testid="form-draft-banner">Your draft from {new Date(form.draft_saved_at).toLocaleString("en-AU")} has been loaded.</div>}
      {form.anonymous && <div className="mb-3 rounded-md border border-[#C2A462]/30 bg-[#C2A462]/10 px-4 py-2 text-sm" data-testid="survey-anonymous-note">This survey is anonymous. Your name isn't saved with your answers.</div>}
      <FormRenderer form={form} onSubmit={submit} onDraft={form.anonymous ? undefined : draft} initial={form.draft || {}} embedded />
    </div>
  );
}
